import type { ExtraHeaders } from '../config';

/** 将对象或 Headers 统一转换为 Axios 可使用的字符串键值对。 */
export function normalizeHeaders(input?: ExtraHeaders | null): Record<string, string> {
    if (!input) {
        return {};
    }

    if (input instanceof Headers) {
        const output: Record<string, string> = {};
        input.forEach((value, key) => {
            output[key] = value;
        });
        return output;
    }

    return Object.fromEntries(
        Object.entries(input)
            .filter(([, value]) => value !== null && value !== undefined && value !== '')
            .map(([key, value]) => [key, String(value)])
    );
}

/** 按默认值、宿主动态值、单次请求值的顺序合并请求头，后者优先。 */
export async function resolveRequestHeaders(
    defaults: ExtraHeaders | undefined,
    extraHeaders:
        | (() => ExtraHeaders | null | undefined | Promise<ExtraHeaders | null | undefined>)
        | undefined,
    requestHeaders?: ExtraHeaders
): Promise<Record<string, string>> {
    return {
        ...normalizeHeaders(defaults),
        ...normalizeHeaders(extraHeaders ? await extraHeaders() : undefined),
        ...normalizeHeaders(requestHeaders),
    };
}
